import React from 'react';
import { Image } from '@thd-olt-component-react/core-ui';
import { WARNING_MESSAGE } from '../../constants/constants';

import './warning-message.scss';

export const WarningMessage = () => {
  return (
    <div className="warning-message">
      <div className="warning-message__image">
        <Image
          asset="alert-warning-yellow.svg"
          title="Alert Icon"
          alt="alert-warning-yellow"
        />
      </div>
      <div>
        { WARNING_MESSAGE }
      </div>
    </div>
  );
};
